module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social",
    class: {
      'social_small-text': _vm.smallText
    }
  }, [_c('div', {
    staticClass: "social__note"
  }, [_vm._v(_vm._s(_vm.text))]), _c('yandex-share', {
    attrs: {
      "services": ['vkontakte', 'odnoklassniki', 'moimir'],
      "title": _vm.title,
      "description": _vm.description,
      "url": _vm.url,
      "counter": "counter"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6c642e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/share/Social.vue
// module id = bca969aec6ed26811236
// module chunks = 0